export default {
  walletSetting: {
    title: "إعدادات المحفظة",
    assetsType: "عرض الأصول بـ:",
    nameType: "عرض أسماء العملات بـ:",
    saveButton: "حفظ التغييرات",
    cancelButton: "عرض",
    assetsTypeList: [
      {
        value: "IRR",
        title: "الريال (IRR)"
      },
      {
        value: "USDT",
        title: "الدولار ($)"
      }
    ],
    nameTypeList: [
      {
        value: "name_locale",
        title: "الفارسية"
      },
      {
        value: "name",
        title: "الإنجليزية"
      }
    ]
  },
  walletHero: {
    allAssetsValue: "إجمالي قيمة الأصول",
    totalProfitLoss: "إجمالي الربح (الخسارة)",
    deposit: "إيداع",
    withdrawal: "سحب",
    exchange: "تبادل",
    transfer: "تحويل إلى السوق",
    otherCurrencies: "عملات أخرى",
    showAssets: "عرض الأصول",
    hideAssets: "إخفاء الأصول"
  },
  walletTable: {
    searchInput: "ابحث عن اسم العملة أو الرمز...",
    hideZeroAssets: "إخفاء الأصول ذات الرصيد الصفري",
    returnToInitialSettings: "العودة إلى الإعدادات الأولية",
    tableLayout: "تخطيط الجدول",
    tableSetting: "الإعدادات",
    rowPerPage: "عدد الصفوف لكل صفحة",
    to: "إلى",
    of: "من",
    symbol: "اسم العملة",
    name: "الاسم",
    totalAsset: "الأصل",
    blockedAsset: "الأصل المحظور",
    availableAsset: "الأصل المتاح",
    currentValue: "القيمة الحالية (IRR)",
    averagePurchasePrice: "متوسط سعر الشراء",
    profitLoss: "الربح / الخسارة",
    profitLossRate: "الربح / الخسارة (IRR)",
    assetPercentageFromTotal: "النسبة المئوية من إجمالي الأصل",
    operation: "العملية",
    update: "تحديث"
  },
  checkMarketTerms: {
    traderTermsDesc:
      "عزيزي المستخدم، لاستخدام قسم سوق Excoino، يجب أولاً قبول قواعد هذا القسم. للقيام بذلك، اذهب إلى قسم سوق Excoino، اقرأ ووافق على القواعد، ثم عد إلى هذه الصفحة لتحويل العملة المشفرة.",
    goToTrader: "اذهب إلى سوق Excoino"
  },
  operationsInTable: {
    deposit: "إيداع",
    withdraw: "سحب",
    exchange: "تبادل",
    transfer: "تحويل إلى السوق"
  },
  noRowsTemplate: {
    noCurrenciesFound: "لم يتم العثور على عملات"
  },
  notLoading: {
    loading: "جاري التحميل"
  }
};
